module.exports = addOnce
function addOnce (element, event, fn) {
  function tmp (ev) {
    element.removeEventListener(event, tmp, false)
    fn(ev, element)
  }
  element.addEventListener(event, tmp, false)
}


//////////////////
// WEBPACK FOOTER
// ./~/web-audio-player/lib/event-add-once.js
// module id = 991
// module chunks = 1 2 3 4 5